<span class="flex items-center gap-2">
  {{ certification().translations | translateDirectus }}
  @if (certification().tooltip?.key) {
    <app-directus-tooltip
      tooltipStyleClass="tooltip-bg-second-level"
      [tooltipKey]="certification().tooltip!.key"
    ></app-directus-tooltip>
  }
</span>
